<template>
	<details
		ref="details"
		class="bg-white border rounded-sm"
		open
		@toggle="updateOpen"
	>
		<summary class="flex items-center h-16 gap-5 px-6 cursor-pointer group">
			<div class="mr-auto flex flex-col">
				<span v-if="subHeading" class="text-sm font-normal text-gray-500">
					{{ subHeading }}
				</span>
				<h2 v-if="heading" class="text-base font-normal">
					{{ heading }}
				</h2>
			</div>
			<slot name="icons" />
			<AppButton
				variant="ghost"
				:class="{ 'rotate-90': isOpen }"
				icon="chevron_forward"
				type="button"
				:aria-label="isOpen ? 'Inklappen' : 'Uitklappen'"
				:aria-expanded="isOpen"
				@click="toggle"
			/>
		</summary>
		<div class="p-6 border-t">
			<slot></slot>
		</div>
	</details>
</template>

<script lang="ts" setup>
import { onMounted, ref, useTemplateRef } from "vue";

interface Props {
	heading?: string;
	subHeading?: string;
}
defineProps<Props>();

const detailsRef = useTemplateRef("details");

const toggle = () => {
	if (detailsRef.value) {
		detailsRef.value.open = !detailsRef.value.open;
	}
};

const isOpen = ref(false);
const updateOpen = () => {
	if (detailsRef.value) {
		isOpen.value = detailsRef.value.open;
	}
};

onMounted(() => {
	if (detailsRef.value) {
		updateOpen();
	}
});
</script>
